import { BANK_OPERATION_KIND } from '@klopotun/domain';
import { z } from 'zod';
import { civilDateSchema, currencyCodeSchema, isoTimestampSchema, uuidSchema } from './common.js';
import { monthQueryParamSchema, NO_CATEGORY_FILTER, yearQueryParamSchema } from './summary.js';
const MAX_CURSOR_LENGTH = 200;
const MAX_MERCHANT_KEY_LENGTH = 1000;
const FIRST_YEAR = 1;
const bankYearSchema = yearQueryParamSchema.refine((year) => year >= FIRST_YEAR, 'there is no year zero');
export const CATEGORY_SOURCE = {
    MCC: 'mcc',
    RULE: 'rule',
    MANUAL: 'manual',
};
export const categorySourceSchema = z.enum(CATEGORY_SOURCE);
export const CATEGORY_CHANGE_SCOPE = {
    TRANSACTION: 'transaction',
    MERCHANT: 'merchant',
};
export const bankOperationKindSchema = z.enum(BANK_OPERATION_KIND);
export const bankOperationSchema = z.object({
    id: uuidSchema,
    occurredAt: isoTimestampSchema,
    occurredOn: civilDateSchema,
    description: z.string(),
    amountMinor: z.int(),
    currency: currencyCodeSchema,
    kind: bankOperationKindSchema,
    categoryId: uuidSchema.nullable(),
    categorySource: categorySourceSchema.nullable(),
    cardId: uuidSchema.nullable(),
});
const operationSubscriptionSchema = z.object({
    paymentId: uuidSchema,
    name: z.string().min(1),
});
export const bankOperationListItemSchema = bankOperationSchema.extend({
    baseAmountMinor: z.int().nullable(),
    subscription: operationSubscriptionSchema.nullable(),
});
const operationPurchaseSchema = z.object({
    amountMinor: z.int(),
    currency: currencyCodeSchema,
});
const operationPeriodSchema = z.object({
    paymentId: uuidSchema,
    name: z.string().min(1),
    occurrenceId: uuidSchema,
    dueDate: civilDateSchema,
});
export const bankOperationDetailSchema = bankOperationSchema.extend({
    baseAmountMinor: z.int().nullable(),
    purchase: operationPurchaseSchema.nullable(),
    subscription: operationPeriodSchema.nullable(),
    isLinkable: z.boolean(),
});
export const bankOperationPageSchema = z.object({
    items: z.array(bankOperationListItemSchema),
    nextCursor: z.string().min(1).nullable(),
});
export const bankOperationsQuerySchema = z.object({
    year: bankYearSchema.optional(),
    month: monthQueryParamSchema.optional(),
    category: z.union([uuidSchema, z.literal(NO_CATEGORY_FILTER)]).optional(),
    merchant: z.string().min(1).max(MAX_MERCHANT_KEY_LENGTH).optional(),
    cursor: z.string().min(1).max(MAX_CURSOR_LENGTH).optional(),
});
export const changeOperationCategoryBodySchema = z.object({
    categoryId: uuidSchema,
    scope: z.enum(CATEGORY_CHANGE_SCOPE),
});
export const changedOperationCategorySchema = z.object({
    transaction: bankOperationSchema,
    changedCount: z.int().min(1),
});
//# sourceMappingURL=bank-transaction.js.map